import type { DemoLinkPlatformType } from '@carboncopyco/types';
import { Dropdown, DropdownItem } from '@carboncopyco/ui';
import { useDemoLinkPlatform } from './DemoLinkModalContext';
import { DemoLinkPlatformItem } from './DemoLinkPlatformItem';
import { demoLinkPlatformTypes } from './consts';

export function DemoLinkPlatformSelect({
  disabled,
  allowed,
}: {
  disabled?: boolean;
  allowed?: boolean;
}) {
  const [platform, setDemoLinkPlatform] = useDemoLinkPlatform();

  if (disabled) {
    return (
      <DemoLinkPlatformItem
        isSelected={false}
        variant="option"
        platform={platform}
      />
    );
  }
  if (!allowed) {
    return (
      <DemoLinkPlatformItem
        disabled
        variant="trigger"
        platform={platform}
      />
    );
  }
  return (
    <div className="flex flex-col">
      <Dropdown
        width="100%"
        triggerElement={
          <DemoLinkPlatformItem
            variant="trigger"
            platform={platform}
          />
        }
      >
        <div
          role="group"
          className="w-[554px] p-5"
        >
          {[
            ...(Object.keys(demoLinkPlatformTypes) as DemoLinkPlatformType[]),
          ].map((platformItemKey) => (
            <DropdownItem
              key={platformItemKey}
              onClick={() => setDemoLinkPlatform(platformItemKey)}
            >
              <DemoLinkPlatformItem
                isSelected={platform === platformItemKey}
                platform={platformItemKey}
              />
            </DropdownItem>
          ))}
        </div>
      </Dropdown>
    </div>
  );
}
